import React from 'react';
import styled from 'styled-components';
import { TableCell, TableFooter, TableRow } from 'material-ui/Table';
import Pagination from 'spark-ui/ui-kitchen/sides/Pagination';
import PaginationRecipient from 'spark-ui/ui-kitchen/sides/PaginationRecipient';
import PaginationConsumer from './PaginationConsumer';
import PaginationCreateGapPacket from 'spark-ui/ui-kitchen/sides/PaginationCreateGapPacket';

const PaginationFooter = ({gridName}) => {
    return (
        <TableFooter>
            <TableRow>
                <TableCell colSpan={1000}>
                    <PaginationContainer>
                        <PaginationConsumer>
                            {gridName === 'safetyletterRecipient' ? (pagination) => <PaginationRecipient {...pagination} gridName={gridName} />
                            : gridName === 'ibRecipient' ? (pagination) => <PaginationRecipient {...pagination} gridName={gridName} />
                            : gridName === 'CreateGapPacketResultsGrid' ? (pagination) => <PaginationCreateGapPacket {...pagination} gridName={gridName} />
                            : (pagination) => <Pagination {...pagination} gridName={gridName} /> }
                        </PaginationConsumer>
                    </PaginationContainer>
                </TableCell>
            </TableRow>
        </TableFooter>
    );
};

const PaginationContainer = styled.div`
    position: relative;
    height: 100%;
    width: 100%;

    & ${Pagination} {
        position: absolute;
        right: 0;
        bottom: 0;
    }
    & ${PaginationRecipient} {
        position: absolute;
        right: 0;
        bottom: 0;
    }
`;

export const ListPagination = styled(({ className }) => (
    <div className={className}>
        <PaginationContainer>
            <PaginationConsumer>{pagination => <Pagination {...pagination} />}</PaginationConsumer>
        </PaginationContainer>
    </div>
))`
    width: 100%;
    height: 3em;
`;

export default PaginationFooter;
